import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (url: string) => {
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-6 md:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
          Browse Product Categories
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
          Select a category below to explore curated Basetao Spreadsheet product collections on our main platform.
        </p>

        <div ref={dropdownRef} className="relative inline-block w-full max-w-md">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between gap-3 px-6 py-4 rounded-xl bg-background-100 border border-background-300/60 text-foreground-800 font-label font-medium text-sm md:text-base hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-grid-line text-primary-500 text-lg"></i>
              Choose a category...
            </span>
            <i className={`ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden z-50 max-h-[420px] overflow-y-auto">
              {categories.map((cat, idx) => (
                <button
                  key={idx}
                  onClick={() => handleSelect(cat.url)}
                  className="w-full flex items-center gap-4 px-5 py-3 text-left text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors duration-150 cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <div className="w-12 h-12 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                    <img
                      src={cat.img}
                      alt={cat.name}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <span className="flex items-center gap-2">
                    <span className="w-6 h-6 flex items-center justify-center rounded-md bg-background-100">
                      <i className={`${cat.icon} text-primary-500 text-xs`}></i>
                    </span>
                    <span className="font-label text-sm font-medium">{cat.name}</span>
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}